import { useCallback, useState } from 'react';

function useToggle(initialState = false): [boolean, () => void, (value: boolean) => void] {
  const [state, setState] = useState<boolean>(initialState);

  const onToggle = useCallback(() => {
    setState((state) => !state);
  }, []);

  return [state, onToggle, setState];
}

export default useToggle;
